import { store } from '@utils/configStore'
import { userProfileReducer } from './slices'

export const injectUserProfileStore = () => store.injectReducer('userProfile', userProfileReducer)
